import { render, staticRenderFns } from "./FooterMinimal.vue?vue&type=template&id=00f08996&scoped=true&"
import script from "./FooterMinimal.vue?vue&type=script&lang=js&"
export * from "./FooterMinimal.vue?vue&type=script&lang=js&"
import style0 from "./FooterMinimal.vue?vue&type=style&index=0&id=00f08996&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f08996",
  null
  
)

export default component.exports